import React from 'react';
import FlexGrid, { FlexGridColumn } from '../../../../components/FlexGrid';
import Heading from '../../../../components/Heading';
import PaddingBox from '../../../../components/PaddingBox';
import { codes } from '../../../../data/translations';
import { isMobileAny } from '../../../../utils/device';
import AuthenticationActionButton from '../AuthenticationActionButton';
import AuthenticationDescription from '../AuthenticationDescription';
import AuthenticationErrorsBox from '../AuthenticationErrorsBox';
import AuthenticationTitle from '../AuthenticationTitle';
import { AuthenticationTwoStepEnterCodeForm } from './AuthenticationTwoStepEnterCodeForm';
import { Chain } from '../../../../components/Icons/Chain';
import RouteLink from '../../../../components/RouteLink';

const androidApp = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
const iosApp = 'https://itunes.apple.com/ru/app/google-authenticator/id388497605';

const AuthenticationTwoStepEnterCode = ({
	authenticationSetActionType,
	translate,
	otpKey,
	qrCodeBase64,
	otpLink,
	handleAuthAppSend,
	errors,
	handleShowConfirmationReset,
}) => {
	return (
		<>
			<AuthenticationTitle>{translate(codes.user.twoStepAuthentication)}</AuthenticationTitle>
			{otpKey && qrCodeBase64 && (
				<>
					<Heading size={5}>{translate(codes.user.downloadAuthenticatiorApp)}</Heading>
					<AuthenticationDescription>
						{translate(codes.user.downloadAuthenticatiorAppDescription)}
					</AuthenticationDescription>
					<PaddingBox bottomSmall>
						<FlexGrid>
							<FlexGridColumn>
								<RouteLink
									href={iosApp}
									styledButton
									size='small'
									target='_blank'
								>
									iOS App
								</RouteLink>
							</FlexGridColumn>
							<FlexGridColumn>
								<RouteLink
									href={androidApp}
									styledButton
									size='small'
									target='_blank'
								>
									Android App
								</RouteLink>
							</FlexGridColumn>
						</FlexGrid>
					</PaddingBox>
					{isMobileAny && (
						<>
							<Heading size={5}>Connect Authenticator app</Heading>
							<AuthenticationDescription>
								Please follow the link below to connect your Authenticator app
							</AuthenticationDescription>
							<PaddingBox bottomSmall>
								<RouteLink
									href={otpLink}
									styledButton
									block
									startIcon={<Chain />}
									size='small'
									forceUseLink
								>
									Connect app
								</RouteLink>
							</PaddingBox>
						</>
					)}
					{!isMobileAny && (
						<>
							<Heading size={5}>{translate(codes.user.scanTheQRCode)}</Heading>
							<AuthenticationDescription>
								{translate(codes.user.scanTheQRCodeDescription)}
							</AuthenticationDescription>
							<div>
								<img
									src={`data:image/png;base64,${qrCodeBase64}`}
									alt='QRCode'
									width={160}
								/>
							</div>
						</>
					)}
					<AuthenticationDescription>
						{translate(codes.user.orEnterTheNextCodeInTheApp)}: {otpKey}
					</AuthenticationDescription>
				</>
			)}
			<Heading size={5}>{translate(codes.user.enterAuthenticationCode)}</Heading>
			<AuthenticationDescription>
				{translate(codes.user.enterTheCodeFromAnAuthenticatiorApp)}
			</AuthenticationDescription>
			{errors && errors.code && <AuthenticationErrorsBox errors={errors.code} />}
			<AuthenticationTwoStepEnterCodeForm
				authenticationSetActionType={authenticationSetActionType}
				translate={translate}
				handleAuthAppSend={handleAuthAppSend}
			/>
			{!(otpKey && qrCodeBase64) && (
				<PaddingBox topSmall>
					<AuthenticationActionButton onClick={handleShowConfirmationReset}>
						{translate(codes.user.resetAuthenticatorApp)}
					</AuthenticationActionButton>
				</PaddingBox>
			)}
		</>
	);
};

export { AuthenticationTwoStepEnterCode };
